import "./cart.scss";
import CartItem from "../CartItem/CartItem";
import { ShopContext } from "../../context/ShopContext";
import { useContext } from "react";

function Cart({ closeCart, products }) {
  const { cartItems } = useContext(ShopContext);

  const getCartTotal = () => {
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = products.find((product) => product.id === item);
        totalAmount += cartItems[item] * itemInfo.price;
      }
    }
    return totalAmount;
  };

  let totalAmount = getCartTotal();

  return (
    <div className="cart-background">
      <div className="cart-container">
        <button
          onClick={() => closeCart(false)}
          className="cart-container__close"
        >
          → Close
        </button>
        <div className="cart-title">
          <h1>
            Your<span> Cart</span>
          </h1>
        </div>
        <div className="cart-items">
          {products.map((item) => {
            if (cartItems[item.id] !== 0) {
              return <CartItem item={item} key={item.id} />;
            }
            return console.log("CartItem mapped out");
          })}
          {totalAmount <= 0 && <h2 className="cart-items__none"> is Empty</h2>}
        </div>
        <div className="cart-bottom">
          <h2>Total: $ {totalAmount}</h2>
          <button>Checkout</button>
        </div>
      </div>
    </div>
  );
}

export default Cart;
